import axios from 'axios';
import { API_URL, EXTERNAL_API_URL } from '../../constants.js';

class CareerService {
    async getJobs() {
        const url = `${API_URL}/get-jobs/`;

        const headers = {
            'Content-Type': 'multipart/form-data',
            'Access-Control-Allow-Origin': '*',
        };

        let formData = new FormData();

        return axios({
            url: url,
            method: 'get',
            crossDomain: true,
            data: formData,
            config: { headers: headers },
        })
            .then(function (response) {
                return response;
            })
            .catch(function (response) {
                return response;
            });
    }

    async getJobDetail(slug) {
        const url = `${API_URL}/get-job-detail/${slug}/`;

        const headers = {
            'Content-Type': 'multipart/form-data',
            'Access-Control-Allow-Origin': '*',
        };

        let formData = new FormData();

        return axios({
            url: url,
            method: 'get',
            crossDomain: true,
            data: formData,
            config: { headers: headers },
        })
            .then(function (response) {
                return response;
            })
            .catch(function (response) {
                return response;
            });
    }

async submitJobApplication(formData) {
    const url = `${API_URL}/send-job-application/`;

    const headers = {
        'Content-Type': 'multipart/form-data',
    };

    return axios({
        url: url,
        method: 'post',
        data: formData,
        headers: headers,
    })
        .then((response) => response)
        .catch((error) => error);
}


}

export default new CareerService();